export default __webpack_public_path__ + "static/b_ver_seminuevos_nissan-b797bbb5cfb7abda152e97406aba2eb3.png";